import React, { useState, useEffect } from "react";
import { useLanguage } from "@/context/LanguageContext";
import LanguageToggle from "@/components/LanguageToggle";

export default function Navbar() {
  const { t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#portfolio", label: t("nav.portfolio"), id: "portfolio" },
    { href: "#services", label: t("nav.services"), id: "services" },
    { href: "#about", label: t("nav.about"), id: "about" },
    { href: "#contact", label: t("nav.contact"), id: "contact" },
  ];

  return (
    <header
      data-testid="main-navbar"
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-500 ${
        scrolled
          ? "glass border-b border-warmBorder/60 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 sm:px-10">
        <a
          href="#top"
          data-testid="brand-logo"
          className={`font-display text-2xl tracking-tight transition-colors ${
            scrolled ? "text-ocean" : "text-white"
          }`}
        >
          Blessed <span className="italic text-terracotta">Algarve</span>
        </a>

        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-${l.id}`}
              className={`text-[11px] uppercase tracking-[0.24em] transition-colors ${
                scrolled
                  ? "text-ocean/70 hover:text-terracotta"
                  : "text-white/80 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-book-cta"
            className={`hidden rounded-sm border px-4 py-2 text-[11px] uppercase tracking-[0.22em] transition-colors duration-300 sm:inline-flex ${
              scrolled
                ? "border-ocean bg-ocean text-sand hover:border-terracotta hover:bg-terracotta"
                : "border-white/70 bg-transparent text-white hover:border-white hover:bg-white hover:text-ocean"
            }`}
          >
            {t("nav.book")}
          </a>
          <LanguageToggle variant={scrolled ? "light" : "dark"} />
        </div>
      </div>
    </header>
  );
}
